/*
 * Kaartengroep (sections/swipe-group.liquid).
 * Pijlen scrollen één kaart verder, videokaarten openen in een dialoogvenster met een speler,
 * en in de theme editor scrolt de groep naar de kaart die wordt aangeklikt.
 */
class RmSwipeGroup extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.rm-swipe__track');
    this.prev = this.querySelector('[data-swipe-prev]');
    this.next = this.querySelector('[data-swipe-next]');
    this.dialog = this.querySelector('.rm-swipe__dialog');
    this.player = this.querySelector('.rm-swipe__player');
    if (!this.track) return;

    if (this.prev && this.next) {
      this.prev.addEventListener('click', () => this.scrollByCards(-1));
      this.next.addEventListener('click', () => this.scrollByCards(1));
      this.onScroll = () => this.updateArrows();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.updateArrows();
    }

    this.querySelectorAll('.rm-swipe__play').forEach((button) => {
      button.addEventListener('click', () => this.openVideo(button));
    });

    if (this.dialog) {
      this.dialog.addEventListener('close', () => this.clearPlayer());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      const close = this.dialog.querySelector('[data-swipe-close]');
      if (close) close.addEventListener('click', () => this.dialog.close());
    }

    this.onBlockSelect = (event) => {
      if (this.contains(event.target) && event.target.classList.contains('rm-swipe__card')) {
        event.target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    };
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    if (this.onScroll) {
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  scrollByCards(direction) {
    const card = this.track.querySelector('.rm-swipe__card');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth - 1;
    const scrollable = max > 1;
    this.prev.disabled = !scrollable || this.track.scrollLeft <= 0;
    this.next.disabled = !scrollable || this.track.scrollLeft >= max;
    this.classList.toggle('is-scrollable', scrollable);
  }

  openVideo(button) {
    if (!this.dialog || !this.player) return;
    const template = button.parentElement.querySelector('template');
    if (!template) return;
    this.player.replaceChildren(template.content.cloneNode(true));
    this.dialog.showModal();
    const video = this.player.querySelector('video');
    if (video) video.play().catch(() => {});
  }

  clearPlayer() {
    const video = this.player.querySelector('video');
    if (video) video.pause();
    this.player.replaceChildren();
  }
}

if (!customElements.get('rm-swipe-group')) {
  customElements.define('rm-swipe-group', RmSwipeGroup);
}
